import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import EdSplitTabs from '@/courses/components/ed-split-tabs/ed-split-tabs.vue';
import { IparamsSplitTabs } from '@/courses/interfaces/params-split-tabs.interface';
import { EdSplitOrientationMixin } from '@/courses/mixins/ed-split-orientation.mixin';

@Component({ 
  name: 'ed-split-horizontal',
  components: {
    EdSplitTabs
  } 
})
export default class EdSplitHorizontal extends Mixins(EdSplitOrientationMixin) { 

  public orientation: string = 'Horizontal';
  
  get splitTabsParams(): IparamsSplitTabs {
    return {
      contentsId: this.contentsId,
      hasSplits: true,
      oneviewSelected: false,
      tabSelected: this.contentsId.splitHorizontal
    }
  }
  
}